module.exports = __webpack_public_path__ + "471093dd27006e1affb75aad55ab1635.svg";